<template>
  <div class="flex flex-col place-content-center">
    <div
      class="mb-8 flex h-16 w-16 items-center justify-center rounded"
      :class="{
        'bg-success-100 text-success-700': variant === 'success',
        'bg-error-100 text-error-700': variant === 'error',
        'bg-warning-100 text-warning-700': variant === 'warning'
      }"
    >
      <font-awesome-icon :icon="icon" class="text-2xl" />
    </div>
    <div class="flex flex-col gap-2">
      <h2 class="max-w-xl text-5xl font-bold leading-[3.5rem] tracking-[-0.04rem] text-neutral-800">
        {{ title }}
      </h2>
      <p class="max-w-xl text-[1.125rem] font-semibold leading-[1.4375rem] tracking-[-0.02rem] text-neutral-500">
        {{ underTitle }}
      </p>

      <InfuseButton type="button" size="large" class="col-span-full" @click="emit('confirm')">
        {{ confirmButtonText }}
      </InfuseButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { InfuseButton } from '@infuse/ui/components';

withDefaults(
  defineProps<{
    variant: 'success' | 'error' | 'warning';
    title: string;
    underTitle: string;
    confirmButtonText: string;
    icon: [string, string];
  }>(),
  {
    variant: 'success',
    icon: () => ['fal', 'circle-check']
  }
);

const emit = defineEmits<{
  (e: 'confirm'): void;
}>();
</script>
